import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPrismicComponent } from './simple-icons-prismic.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPrismicComponent ],
    exports:      [ SimpleIconsPrismicComponent ],
    bootstrap:    []
})
export class SimpleIconsPrismicModule {}
